module.exports = __webpack_public_path__ + "assets/images/hdl_g.a1a76ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hdl_g.png
// module id = 723
// module chunks = 1